// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1ZqSY","row":"Node_row__ldCq1","label":"Node_label__2R4CQ","footer":"Node_footer__1IGOv"};